import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { UserService } from '../../global/userService/user-service';
import { ArmyBuilderConfig } from '../../global/config';
import { firstValueFrom } from 'rxjs';

@Component({
    standalone: true,
    selector: 'abs-billing-simulation-bar',
    imports: [CommonModule, IonicModule],
    template: `
        @if (userService.user()?.adminBillingSimulation) {
            <div class="simulation-bar">
                <span class="label">Billing Simulation Active</span>
                <ion-button size="small" color="light" fill="clear" (click)="clearSimulation()"> Clear </ion-button>
            </div>
        }
    `,
    styles: [
        `
            .simulation-bar {
                display: flex;
                align-items: center;
                justify-content: center;
                gap: 4px;
                padding: 4px 12px;
                background: #f57c00;
                color: #fff;
                font-size: 13px;
                z-index: 9999;
                flex-wrap: wrap;
            }
            .label {
                font-weight: 600;
                margin-right: 4px;
            }
        `
    ]
})
export class BillingSimulationBarComponent {
    userService = inject(UserService);
    config = inject(ArmyBuilderConfig);

    async clearSimulation() {
        const userId = this.userService.user()?.userId;
        if (!userId) return;

        await firstValueFrom(
            this.userService.adminOnlyRoute('post', this.config.apiBaseUrl + '/user/admin/simulate-billing-issue', {
                userId: userId,
                state: 'clear'
            })
        );
        // Refresh token to clear the flag from the UI state
        await this.userService.refreshAccessToken();
    }
}
